function getVariantFromDOM() {
  const el = document.querySelector('[data-selected-variant]');
  if (!el) return null;

  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return null;
  }
}

function waitForVariantReady(callback) {
  const interval = setInterval(() => {
    const variant = getVariantFromDOM();
    const wrappedId = window.Wrapped?.selectedVariantId;

    const finalVariant = variant || (wrappedId ? { id: wrappedId } : null);

    if (!finalVariant) return;

    clearInterval(interval);
    callback(finalVariant);
  }, 50);
}


function getSelectedVariant() {
  const el = document.querySelector('[data-selected-variant]');
  if (!el) return null;

  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return null;
  }
}

function updateDelivery() {
  const root = document.querySelector('#delivery-message');
  if (!root) return;

  const instockEl = root.querySelector('.is-instock');
  const preorderEl = root.querySelector('.is-preorder');

  if (!instockEl || !preorderEl) return;

  const variant = getSelectedVariant();
  if (!variant) return;

  const isInStock = (() => {
  const raw = (variant.title || variant.option1 || '').toLowerCase();

  return (
    raw.includes('in-stock') ||
    raw.includes('instock') ||
    raw.includes('in stock')
  );
})();

  instockEl.hidden = !isInStock;
  preorderEl.hidden = isInStock;
}


function initVariantSystems() {
  let lastId = null;

  function run(variant) {
    if (!variant) return;

    if (variant.id === lastId) return;
    lastId = variant.id;

    updateDelivery();

    // OPTIONAL: sync pickup system safely if needed
    const pickup = document.querySelector('pickup-availability');
    if (pickup?.update) {
      pickup.update(variant);
    }
  }

  waitForVariantReady((variant) => {
    run(variant);
  });

  setInterval(() => {
    const variant = getVariantFromDOM() || {
      id: window.Wrapped?.selectedVariantId
    };

    if (variant?.id !== lastId) {
      run(variant);
    }
  }, 200);
}

document.addEventListener('DOMContentLoaded', initVariantSystems);